import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    .ant-slider {
      .ant-slider-rail {
        height: 16px;
        background-color: ${theme.colors.neutralSilver10};
        border-radius: 16px;

        &:hover {
          background-color: ${theme.colors.neutralSilver10};
        }
      }

      .ant-slider-track {
        height: 16px;
        background-color: ${theme.colors.primary70};
        border-radius: 16px;
      }

      .ant-slider-handle {
        width: 25px;
        height: 25px;
        margin-top: -5px;
        background-color: ${theme.colors.primary70};
        border: 2px solid ${theme.colors.globalWhite100};
        border-radius: 50%;

        &:focus {
          box-shadow: none;
        }
      }

      &:hover {
        .ant-slider-handle {
          background-color: ${theme.colors.primary70};
          border: 2px solid ${theme.colors.globalWhite100};
        }
      }
    }
  `}
`;
